import React from 'react';
import { useI18n, type LanguageType } from '../i18n/useI18n';

export const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage, t } = useI18n();

  return (
    <select
      value={language}
      onChange={(e) => setLanguage(e.target.value as LanguageType)}
      aria-label={t('common.language') ?? 'Language'}
      className="h-8 rounded-md bg-transparent px-1 text-sm font-medium text-zinc-600 cursor-pointer outline-none focus-visible:ring-2 focus-visible:ring-zinc-400 focus-visible:ring-offset-1 hover:text-zinc-900 transition-colors"
    >
      <option value="en">EN</option>
      <option value="zh">CN</option>
    </select>
  );
};
